import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {
    FaInstagram,
    FaPlay,
    FaImages
} from "react-icons/fa";

import s from "./InstagramSection.module.scss";
import api from "../../api/client";


const apiUrl = process.env.REACT_APP_API_URL;


export default function InstagramSection(){

    const [profile,setProfile] = useState(null);
    const [posts,setPosts] = useState([]);

    const scrollRef = useRef(null);

    const [active,setActive] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [hasDragged, setHasDragged] = useState(false);

    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const velocity = useRef(0);
    const lastX = useRef(0);
    const animation = useRef(null);
    useEffect(()=>{

        api.get(`/api/instagram`)
            .then(res=>{

                setProfile(res.data.profile);
                setPosts(res.data.posts);

            });


    },[]);






    const handleMouseDown = (e) => {

        const container = scrollRef.current;

        setIsDragging(true);
        setHasDragged(false);


        startX.current = e.pageX;
        scrollLeft.current = container.scrollLeft;


        lastX.current = e.pageX;
        velocity.current = 0;


        container.style.scrollSnapType = "none";

    };



    const handleMouseMove = (e) => {

        if(!isDragging) return;


        const container = scrollRef.current;


        const walk =
            e.pageX - startX.current;


        if(Math.abs(walk) > 5){
            setHasDragged(true);
        }


        velocity.current =
            e.pageX - lastX.current;


        lastX.current = e.pageX;


        container.scrollLeft =
            scrollLeft.current - walk;

    };



    const momentumScroll = ()=>{

        const container = scrollRef.current;


        if(Math.abs(velocity.current) < 0.5){

            container.style.scrollSnapType =
                "x mandatory";

            return;

        }


        container.scrollLeft -= velocity.current;


        velocity.current *= 0.95;


        animation.current =
            requestAnimationFrame(momentumScroll);

    };



    const stopDragging = ()=>{


        if(!isDragging) return;


        setIsDragging(false);


        cancelAnimationFrame(animation.current);


        animation.current =
            requestAnimationFrame(momentumScroll);


    };


    const handleMouseLeave = () => {

        setIsDragging(false);

    };
    const handleScroll = ()=>{

        const container = scrollRef.current;

        if(!container) return;


        const index = Math.round(
            container.scrollLeft /
            container.clientWidth
        );


        setActive(index);

    };



    if(!profile) return null;


    return (

        <section className={s.instagram}>


            <div className={s.header}>


                <div className={s.profile}>

                    <img
                        src={profile.profile_picture_url}
                    />


                    <div>

                        <h3>
                            {profile.name}
                        </h3>

                        <span>
                            @{profile.username}
                        </span>

                    </div>

                </div>



                <a
                    href={`https://instagram.com/${profile.username}`}
                    target="_blank"
                    rel="noreferrer"
                >

                    <FaInstagram/>
                    Instagram

                </a>


            </div>



            <div
                className={`${s.posts} ${isDragging ? s.dragging : ""}`}
                ref={scrollRef}
                onScroll={handleScroll}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={stopDragging}
                onMouseLeave={stopDragging}
            >

                {
                    posts.map(post=>{


                        const image =
                            post.media_type === "VIDEO"
                                ? post.thumbnail_url
                                : post.media_url;


                        return (

                            <div

                                key={post.id}

                                className={s.card}

                                onClick={()=>{

                                    if(!hasDragged){

                                        window.open(
                                            post.permalink,
                                            "_blank"
                                        );

                                    }

                                }}

                            >

                                <img
                                    src={image}
                                    alt=""
                                />


                                <div className={s.overlay}>


                                    {
                                        post.type==="VIDEO" &&
                                        <FaPlay/>
                                    }


                                    {
                                        post.type==="CAROUSEL_ALBUM" &&
                                        <FaImages/>
                                    }


                                </div>


                            </div>

                        )


                    })
                }


            </div>



            <div className={s.indicator}>

                {
                    Array.from({
                        length:
                            Math.ceil(posts.length / 4)
                    })
                        .map((_,i)=>(

                            <span
                                key={i}
                                className={
                                    active===i
                                        ? s.active
                                        :""
                                }
                            />

                        ))
                }

            </div>


        </section>

    )

}